import { API_URL, getHeadersWithToken } from "../utils/headers";

/**
 * Error de acceso al vivo, con el estado de suscripción adjunto para que la UI
 * pueda distinguir "sin saldo" de "ventana vencida" sin volver a preguntar.
 */
export class PlaybackAccessError extends Error {
    constructor(message, { status, access } = {}) {
        super(message);
        this.name = 'PlaybackAccessError';
        this.status = status;
        this.access = access;
    }
}

/**
 * Solicita un ticket de reproducción de vida corta.
 *
 * Es la única vía autorizada para abrir la señal: el reproductor ya no
 * construye la URL a partir del `streaming_token`, y MediaMTX rechaza cualquier
 * lectura sin un ticket válido.
 */
export const fetchPlaybackTicketService = async (modelId) => {
    const response = await fetch(`${API_URL}/model/${modelId}/playback`, {
        headers: getHeadersWithToken(),
    });

    const result = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new PlaybackAccessError(
            result?.error || result?.message || 'No fue posible iniciar la reproducción',
            { status: response.status, access: result?.access }
        );
    }

    return result?.data;
};
